// @ts-strict-ignore
import { Columns } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Arrange, Button, Link, Spacer, Typography, HTML, Separator } from "@aviary";
import { l } from "@clinic/emerson/locales";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import type { WordpressFeaturedItemType } from "@emerson/data/queries/WordpressFeaturedItemsQuery/WordpressFeaturedItemsQuery.query";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import { MockFeaturedBrands } from "./MockFeatureBrands";

import * as styles from "./FeaturedBrands.styles";

interface Props {
  brands: WordpressFeaturedItemType[];
}

const FeaturedBrands = ({ brands }: Props) => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const isDesktop = tablet.greaterThan;
  const columnWidth = isDesktop ? 4 : 6;

  const mockedFeaturedBrands: WordpressFeaturedItemType[] = MockFeaturedBrands.map(
    (brand, index) => {
      return {
        featuredType: "FeaturedBrand",
        featuredBrandId: brand.id,
        featuredBrandActionUrl: emersonRoutes.getBrand(brand?.name, brand?.id),
        featuredBrandLogo: brand.logo,
        featuredBrandImage: brand.image,
        featuredBrandName: brand.name,
        featuredBrandText: brand.desc,
        featuredDisplayOrder: index,
        id: brand.id,
      } as WordpressFeaturedItemType;
    }
  );

  let featuredBrands: WordpressFeaturedItemType[] = mockedFeaturedBrands;
  if (brands.length > 0) {
    featuredBrands = brands.slice(0, 3);
  }

  const renderBrands = () =>
    featuredBrands.map((brand, index) => {
      const brandLink =
        brand.featuredBrandActionUrl ||
        emersonRoutes.getBrand(brand.featuredBrandName, brand.featuredBrandId);

      return (
        <Columns.Column key={`${brand.featuredBrandName}-${index}`} columnWidth={columnWidth}>
          <Arrange isVertical isFullWidth css={styles.FeaturedBrandBox}>
            <Link to={brandLink} css={styles.FeaturedBrandLogo}>
              <img src={brand.featuredBrandLogo} alt={brand.featuredBrandName} />
            </Link>
            <Separator />
            <div css={styles.FeaturedBrandBottomBox}>
              <div css={styles.FeaturedBrandImage}>
                <Link to={brandLink}>
                  <img src={brand.featuredBrandImage} alt={brand.featuredBrandName} />
                </Link>
              </div>
              <div css={styles.FeaturedBrandContent}>
                <HTML
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  dangerouslySetInnerHTML={{ __html: brand.featuredBrandText }}
                />
                <Button to={brandLink}>{t(l.homepage.common.Shop)}</Button>
              </div>
            </div>
          </Arrange>
        </Columns.Column>
      );
    });

  return (
    <>
      <Spacer height="double" />
      <Typography type="h2">{t(l.homepage.common.FeaturedBrands)}</Typography>
      <Columns>{renderBrands()}</Columns>
      <Spacer height="oneHalf" />
    </>
  );
};

export { FeaturedBrands };
